class Controller {
  constructor($mdDialog) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.customerQueryParams = { isCityRequired: false, active: true };
  }

  isAddNewManagerDisabled() {
    const lastManager = this.managers[this.managers.length - 1];
    const isLastMangerNew = !lastManager;

    return this.managers.length && isLastMangerNew;
  }

  addNewManager() {
    this.managers.push(undefined);
  }

  preDeleteManager(manager) {
    const confirm = this.$mdDialog
      .confirm()
      .title(`Are you sure you want to remove "${manager.name}"?`)
      .ok("Confirm")
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(() => this.deleteManager(manager));
  }

  deleteTemporary() {
    this.managers.pop();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/fleetAdminManagement/fleetAdminManagement.controller.js